import React from 'react';

import SpBasicTemplate from 'components/templates/SpBasicTemplate';
import SpStepProgressBar from 'components/molecules/SpStepProgressBar';
import SpInputTitle from 'components/molecules/SpInputTitle';
import SpFreeInputArea from 'components/molecules/SpFreeInputArea';
import SpPointComment from 'components/molecules/SpPointComment';
import SpInputItem from 'components/molecules/SpInputItem';
import SpModal from 'components/molecules/SpModal';
import PcErrorArea from 'components/molecules/PcErrorArea';
import './index.sp.scss';

import {
  POINT_COMMENT_MAP
} from 'utils/constant';

const PresentSP = ({
  dutyDip,
  workInfoContentDip,
  workInfoContentCmntDip,
  workInfoContentModal,
  onClickMainButton,
  isApiError,
  valid
}) => (
  <div className="AddJobDescription SP">
    <SpBasicTemplate
      path={window.location.pathname}
      onClickMainButton={onClickMainButton}
      isApiError={isApiError}
      valid={valid}
    >
      <SpStepProgressBar currentStep={3}></SpStepProgressBar>
      <div className='titleArea'>
        <div className='title'>
          職種・業務内容
        </div>
      </div>
      <div id="jd" className="contents mT60">
        <SpPointComment labelList={POINT_COMMENT_MAP.jdPointCmnt.labelList} pattern={POINT_COMMENT_MAP.jdPointCmnt.pattern} />
        <div className="jd">
          <SpInputTitle
            title={dutyDip.title}
            label={dutyDip.label}
            subTitle={dutyDip.subTitle}
            list={dutyDip.list}
            type={dutyDip.type}
            comment={!dutyDip.comment ? (<></>) : (
              <>
                <SpFreeInputArea
                  visible={dutyDip.comment.visible}
                  title={dutyDip.comment.title}
                  label={dutyDip.comment.label}
                  questionMark={dutyDip.comment.questionMark}
                  popUpTitle={dutyDip.comment.popUpTitle}
                  popUpDetail={dutyDip.comment.popUpDetail}
                  relativePosArrow={dutyDip.comment.relativePosArrow}
                  name={dutyDip.comment.name}
                  textAreaValue={dutyDip.comment.textAreaValue}
                  cmntOnChange={dutyDip.comment.cmntOnChange}
                  onInput={dutyDip.comment.onInput}
                  onCompositionEnd={dutyDip.comment.onCompositionEnd}
                  maxLength={dutyDip.comment.maxLength}
                  placeholder={dutyDip.comment.placeholder}
                  rows={dutyDip.comment.rows}
                  cols={dutyDip.comment.cols}
                  wordCount={dutyDip.comment.wordCount}
                  errMessage={dutyDip.comment.errMessage}
                  inValid={dutyDip.comment.inValid}
                />
              </>
            )}
          />
          <div id='workInfoContentDip'>
            <SpInputItem
              title={workInfoContentDip.title}
              label={workInfoContentDip.label}
              subTitle={workInfoContentDip.subTitle}
              questionMark={false}
            >
              {workInfoContentDip.list}
            </SpInputItem>
            <SpModal
              modalIsOpen={workInfoContentModal.modalIsOpen}
              content={workInfoContentModal.content}
              button={workInfoContentModal.button}
              onClickCloseButton={workInfoContentModal.onClickCloseButton}
              onClickBackButton={workInfoContentModal.onClickBackButton}
              max={workInfoContentModal.max}
              current={workInfoContentModal.current}
              mdName={workInfoContentModal.mdName}
              mdNote={workInfoContentModal.mdNote}
              style={workInfoContentModal.style}
            />
          </div>
          <div id='workInfoContentCmntDip'>
            <SpInputTitle
              title={workInfoContentCmntDip.title}
              label={workInfoContentCmntDip.label}
              list={workInfoContentCmntDip.list}
              type={workInfoContentCmntDip.type}
            />
            <span className=''>
              <PcErrorArea position='relative' message={workInfoContentCmntDip.errMessage} />
            </span>
          </div>
        </div>
      </div>
    </SpBasicTemplate>
  </div>
);

export default PresentSP;